import { RECRUITERCLIENTCERTIFICATE } from "../../ENVIRONMENT";

// api for recruiter certificate list
function reccertificateList(token) {
  const response = fetch(RECRUITERCLIENTCERTIFICATE, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { reccertificateList };
